import { styled } from '@vebox/etui-system';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { H1 as H1$1 } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const H1 = styled(H1$1).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({
    display: 'block',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    mt: 0,
    mb: 0
  }, theme.typography.h1), props);
})``;

export { H1 };
